import classNames from "classnames";
import * as React from "react";

export interface InterfaceThemeProvider {
  theme?: boolean;
  children: React.ReactNode;
}

function ThemeProvider({
  theme = false,
  children,
}: InterfaceThemeProvider): JSX.Element {
  const className = classNames(theme ? "nimbus-web--theme--light" : "nimbus-web--theme--dark");

  return (
    <div className={className}>
      {children}
    </div>
  );
}

export default ThemeProvider;